export default "<app-color-swatch-picker [color]=\"value\" (colorChange)=\"valueChange.emit($event)\"></app-color-swatch-picker>\n"